import { MandatoryParamsEmptyState } from "app/components/React/HOCs/accessWithoutMandatoryParamsHOC";
import type { AdIntelligenceController } from "app/pages/digital-marketing/ad-intelligence/common/shared/types/types";
import { useSelectedIndustry } from "app/pages/digital-marketing/ad-intelligence/shared/components/AssetPicker/useSelectedIndustry";

import { IndustryAds } from "./IndustryAds";
import { WebsiteAds } from "./WebsiteAds";

interface IDisplayAdsProps {
    controller?: AdIntelligenceController;
}

export const DisplayAds = ({ controller = "advertiser" }: IDisplayAdsProps) => {
    const { industry, industryParam } = useSelectedIndustry();

    if (controller === "advertiser" && industry) {
        return <IndustryAds category={industry} />;
    }
    // Industry param present but unresolvable: show the empty state instead of
    // falling through to WebsiteAds (which crashes on the absent `key`).
    if (controller === "advertiser" && industryParam) {
        return <MandatoryParamsEmptyState missingItemType="advertiser" />;
    }
    return <WebsiteAds controller={controller} />;
};
